import styled from 'styled-components';
import { devices } from '../../styles/viewports.styles';
export const HeaderContainer = styled.div.withConfig({
  displayName: "Headerstyles__HeaderContainer",
  componentId: "r1dedb-0"
})(["grid-column-start:2;grid-column-end:span 3;display:flex;justify-content:space-between;align-items:center;margin:1rem 0;min-height:50px;"]);
export const Logo = styled.div.withConfig({
  displayName: "Headerstyles__Logo",
  componentId: "r1dedb-1"
})(["order:1;margin-left:auto;@media ", "{margin-top:1rem;order:initial;margin-left:0;}"], devices.desktop);
export const AccountSelector = styled.div.withConfig({
  displayName: "Headerstyles__AccountSelector",
  componentId: "r1dedb-2"
})(["@media ", "{margin-left:auto;}margin-bottom:", ";"], devices.desktop, props => props.displayBackLink ? '8px' : '0');